import React, { useState, useEffect } from "react";
import classes from "./styles/style.module.css";
import { FaCheck } from "react-icons/fa6";

const CustomCheckBox = ({ val, handleChange, label, disabled, dark }) => {
  const [checked, setChecked] = useState(val || false);

  useEffect(() => {
    setChecked(val);
  }, [val]);

  const handleCheck = (check) => {
    if (!disabled) {
      setChecked(check);
      handleChange(check);
    }
  };

  return (
    <div className={classes.container}>
      <div
        className={classes.checkBox}
        id={label}
        onClick={() => handleCheck(!checked)}
      >
        {checked && (
          <div
            className={classes.check}
            style={{ background: dark ? "#F2AD17" : "" }}
          >
            <FaCheck color="#fff" size={14} />
          </div>
        )}
      </div>
      <label htmlFor={label} onClick={() => handleCheck(!checked)} className="pointer">
        {label}
      </label>
    </div>
  );
};

export default CustomCheckBox;
